import { Component, Input, EventEmitter, SimpleChanges, OnInit, Output, OnChanges } from '@angular/core';
import { 
  NbGlobalPhysicalPosition,
  NbGlobalPosition,
  NbComponentStatus,
  NbToastrService 
} from '@nebular/theme';

@Component({
  selector: 'nbx-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class FileUploadComponent implements OnInit{
  @Input() shape = "semi-round";
  @Input() size = "medium";
  @Input() choosestatus = "primary";
  @Input() disabled = "false";
  @Input() type = "text";
  @Input() placeholder = "Input";
  @Input() validext: any;
  @Input() duration = 2000;
  @Input() toastposition: string = 'top-right';
  @Input() inputname: string = 'myfile';

  @Output() fileUploaded = new EventEmitter();

  toaststatus: NbComponentStatus = 'primary';
  message = 'Example Message';
  title = 'Title';

  showNotification = false;

  private index: number = 0;

  constructor(private toastrService: NbToastrService) {
  }

  file = "";

  position = NbGlobalPhysicalPosition.TOP_RIGHT

  ngOnInit() {

    
  }

  showToast() {
    switch(this.toastposition) { 
      case 'top-right': { 
         //statements; 
         this.position = NbGlobalPhysicalPosition.TOP_RIGHT;

         break; 
      } 
      case 'top-left': { 
         //statements; 
         this.position =  NbGlobalPhysicalPosition.TOP_LEFT;

         break; 
      }
      case 'bottom-right': { 
        //statements; 
        this.position = NbGlobalPhysicalPosition.BOTTOM_LEFT;
        break; 
      }
      case 'bottom-left': { 
        //statements; 
        NbGlobalPhysicalPosition.BOTTOM_RIGHT;
        break; 
      }  
      default: { 
         //statements; 
         this.position = NbGlobalPhysicalPosition.TOP_RIGHT;
         break; 
      } 
   }; 

    const duration = this.duration;
    let status = this.toaststatus;
    let position = this.position;
    this.toastrService.show(
      this.message,
      this.title || 'Title',
      { position, status, duration });
  }

  handleChange(fileInput)
  {
    // this.showToast();
    let fileData = fileInput.target.files[0];
    let path = fileInput.target.value;

    if (fileData)
    {
      this.file = fileData.name;

      if (this.validext && !this.ExtValid(this.file))
      {
        console.log(this.validext);
          this.title = 'File not supported';
          this.message = "Sorry, we could not upload the file. The file type is not supported.";
          this.toaststatus = 'danger';
          this.showToast();
          path = 'error';
      }
    }
    else
    {
      this.file = '';
      this.title = 'No files selected';
      this.message = 'Please select a file to continue.';
      this.toaststatus = 'danger';
      this.showToast();
      path = 'error';
    }

    this.fileUploaded.emit(path);

  }

  ExtValid(filename) {

    var splitExt = filename.split(".");

    let exts = this.validext.split(',');

    if (splitExt.length > 0)
    {
        var ext = splitExt[1];

        if (exts.includes(ext))
        {
          return true;
        }
    }
    return false;

  }

  // showFilename(fileInput)
  // {
  //   let fileData = fileInput.target.files[0];

  //   let path = fileInput.target.value;

  //   if(path.length > 0)
  //   {
  //     this.fileUploaded.emit(path);
  //   }

  //   if (fileData)
  //   {
  //     this.file = fileData.name;
  //   }
  //   else
  //   {
  //     this.file = '';
  //   }
  // }
}
